export const defaultHover = '200ms'

export default defaultHover
